export default __webpack_public_path__ + "static/media/rating_2.d521e2be.png";